import { Box, Grid } from "@mui/material";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import { useState, useEffect } from "react";
import ReusableButton from "../components/general/ReusableButton";
import NunitoText from "../components/general/NunitoText";
import { GR } from "country-flag-icons/react/3x2";
import ReusableTextField from "../components/general/ReusableTextField";
import {
  useLocation,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { useSnackbar } from "notistack";
import { configureAwardsCriteria } from "../functions/postData";
import { showNotification } from "../functions/snackbar";
import { getTeamBasedAwardsCriteria } from "../functions/getData";
const AwardsCertiria = () => {
  let location = useLocation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();
  const id = location.search.slice(4);
  const [loading, setLoading] = useState(false);
  const [awards, setAwards] = useState([
    {
      name: "",
      percentage: null,
    },
  ]);
  const addAward = () => {
    setAwards([...awards, { name: "", percentage: null }]);
  };
  const deleteAward = (index) => {
    setAwards(awards.filter((_, i) => i !== index));
  };

  const handleGetAwardsCriteria = async () => {
    try {
      setLoading(true);
      const res = await getTeamBasedAwardsCriteria(id);
      setAwards(res);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetAwardsCriteria();
  }, []);

  const handleSave = async () => {
    // Validate that every award has a name and percentage
    const invalidAwards = awards.filter(
      (award) =>
        !award.name ||
        award.name.trim() === "" ||
        award.percentage === null ||
        award.percentage === undefined
    );

    if (invalidAwards.length > 0) {
      showNotification(
        "error",
        "Please fill in all the fields for each award.",
        enqueueSnackbar,
        closeSnackbar
      );
      return;
    }

    try {
      setLoading(true);
      const res = await configureAwardsCriteria(id, awards);
      if (!res?.errors) {
        showNotification(
          "success",
          "Awards criteria configured successfully",
          enqueueSnackbar,
          closeSnackbar
        );
        history.push(`/teamcompetitions`);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  console.log(awards);
  return (
    <Box className="wrapperBox">
      <LoadingBackdrop loading={loading} />
      <Grid
        className="firstRowContainer"
        container
        justifyContent="space-between"
      >
        <NunitoText
          value="Awards Criteria"
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
        <Grid
          width={"95%"}
          className="searchAndBtnContainer"
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <ReusableButton
            text={"Add Award"}
            fontSize={15}
            height={47}
            marginBottom={30}
            bgColor={"#5E75C3"}
            onClick={() => {
              addAward();
            }}
          />
        </Grid>
        <Grid
          width={"95%"}
          marginLeft={10}
          alignItems="flex-start"
          display="flex"
          flexDirection="column"
        >
          <Grid
            display="flex"
            justifyContent="space-between"
            gap={10}
            marginBottom={2}
          >
            <NunitoText
              value="Label"
              fontSize={18}
              fontWeight={600}
              width={200}
            />

            <NunitoText
              value="Percentile"
              fontSize={18}
              fontWeight={600}
              width={200}
            />
          </Grid>
          {awards.map((award, index) => (
            <Grid
              marginTop={3}
              display="flex"
              gap={10}
              width={"100%"}
              alignItems="flex-start"
            >
              <ReusableTextField
                type="default"
                placeholder="Label"
                width={200}
                height={40}
                fontSize={18}
                fontWeight={600}
                state={award.name}
                setState={(value) => {
                  setAwards(
                    awards.map((a, i) =>
                      i === index ? { ...a, name: value } : a
                    )
                  );
                }}
              />
              <ReusableTextField
                number
                type="default"
                placeholder="Percentile"
                width={200}
                height={40}
                fontSize={18}
                fontWeight={600}
                state={award.percentage ?? ""}
                setState={(value) => {
                  setAwards(
                    awards.map((a, i) =>
                      i === index
                        ? { ...a, percentage: value === "" ? null : value }
                        : a
                    )
                  );
                }}
              />
              <ReusableButton
                text="Delete"
                iconType="delete"
                fontSize={15}
                height={40}
                disabledButton={awards.length === 1}
                greyedOut={awards.length === 1}
                bgColor={"#E83042"}
                onClick={() => {
                  deleteAward(index);
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Grid
          width={"95%"}
          className="searchAndBtnContainer"
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <ReusableButton
            text={"Save"}
            fontSize={15}
            height={47}
            iconType="save"
            marginBottom={30}
            bgColor={"#5E75C3"}
            onClick={handleSave}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AwardsCertiria;
